<template>
  <div class="teacherProtocolManage">
    <TeacherProtocolManage :product-id="productId" />
  </div>
</template>

<script>
import TeacherProtocolManage from './protocolManage.vue';
export default {
  name: 'TeacherUserProtocolManage',
  components: {
    TeacherProtocolManage
  },
  data() {
    return {
      productId: 'B11'
    };
  }
};
</script>
